import { FormModalControlled, type FormModalControlledProps } from "@common/controls/Modal/Modals/Form/component";
import classNames from "classnames";
import React from "react";
import { RichEditorContext } from "./context";

export type Props<T> = FormModalControlledProps<T>;

const Modal = <T extends object>(props: Props<T>) => {
  const context = React.useContext(RichEditorContext);

  React.useEffect(() => {
    if (props.isVisible) {
      context.setHasOpenModal(true);
    } else {
      context.setHasOpenModal(false);
    }

    return () => {
      context.setHasOpenModal(false);
    };
  }, [props.isVisible]);

  return <FormModalControlled {...props} className={classNames(props.className, "no-close-click-outside")} />;
};
export default Modal;
